import React, { useEffect } from 'react';
import countries from '../utils/countries.json';

const MiscellaneousMatters = ({ formData, handleChange }) => {
  useEffect(() => {
    if (formData?.investorType === 'individual' && formData?.miscMatters?.representType !== 'individualHuman') {
      handleChange({
        target: {
          name: 'miscMatters.representType',
          value: 'individualHuman'
        }
      });
    }
  }, [formData?.investorType, formData?.miscMatters?.representType, handleChange]);

  useEffect(() => {
    if (formData?.investorType === 'jointSpouse' && formData?.miscMatters?.representType !== 'jointTenancy') {
      handleChange({
        target: {
          name: 'miscMatters.representType',
          value: 'jointTenancy'
        }
      });
    }
  }, [formData?.investorType, formData?.miscMatters?.representType, handleChange]);

  useEffect(() => {
    if (formData?.investorType === 'revocableGrantorTrust' && formData?.miscMatters?.representType !== 'grantorTrust') {
      handleChange({
        target: {
          name: 'miscMatters.representType',
          value: 'grantorTrust'
        }
      });
    }
  }, [formData?.investorType, formData?.miscMatters?.representType, handleChange]);

  useEffect(() => {
  const type = formData?.investorType;
  const isSelfDirectedIRA = type === 'selfDirectedIRA';

  const shouldForceFalse =
    !isSelfDirectedIRA &&
    ['individual', 'jointSpouse', 'revocableGrantorTrust'].includes(type) &&
    formData?.miscMatters?.subject4975 !== 'false';

  if (shouldForceFalse) {
    handleChange({
      target: {
        name: 'miscMatters.subject4975',
        value: 'false',
      },
    });
  }
}, [formData?.investorType, formData?.miscMatters?.subject4975, handleChange]);

useEffect(() => {
  const type = formData?.investorType;
  const isSelfDirectedIRA = type === 'selfDirectedIRA';
  const shouldForceTrue =
    isSelfDirectedIRA &&
    formData?.miscMatters?.subject4975 !== 'true';

  if (shouldForceTrue) {
    handleChange({
      target: {
        name: 'miscMatters.subject4975',
        value: 'true',
      },
    });
  }
}, [formData?.investorType, formData?.miscMatters?.subject4975, handleChange]);
 
  

  return (
    <div>
      <fieldset className="form-field">
        <legend>
          (a) The Subscriber is an individual retirement account or annuity or other “plan” that is subject to Code §4975 or a self-directed account in an “employee benefit plan” within the meaning of Section 3(3) of the U.S. Employee Retirement Income Security Act of 1974, as amended, and the rules and regulations promulgated thereunder (“ERISA”), that is subject to Part 4 of Subtitle B of Title I of ERISA.                          
        </legend>
        {/* True option */}
        <label>
          <input
            type="radio"
            name="miscMatters.subject4975"
            value="true"
            checked={formData?.miscMatters?.subject4975 === 'true'}
            onChange={handleChange}
            required
            disabled={
              formData?.investorType === 'individual' ||
              formData?.investorType === 'jointSpouse' ||
              formData?.investorType === 'revocableGrantorTrust' ||
              formData?.investorType === 'selfDirectedIRA'
            }                      
          /> 
          True
        </label>
        <br/>

        {/* False option */}
        <input
          type="radio"
          name="miscMatters.subject4975"
          value="false"
          checked={formData?.miscMatters?.subject4975 === 'false'}
          onChange={handleChange}
          disabled={
            formData?.investorType === 'individual' ||
            formData?.investorType === 'jointSpouse' ||
            formData?.investorType === 'revocableGrantorTrust' ||
            formData?.investorType === 'selfDirectedIRA'
          }
        />
        False

        {formData?.miscMatters?.subject4975 === 'false' && (
            <div style={{ marginTop: '10px' }}>
                ⚠️ <i> This answer was auto-populated based on your previous responses. If you think the answer is incorrect,
                please review your investor type selection.
                </i>
            </div>
            )}

        {formData?.miscMatters?.subject4975 === 'true' && (
            <div style={{ marginTop: '10px' }}>
                ⚠️ <i> This answer was auto-populated based on your previous responses. If you think the answer is incorrect,
                please review your investor type selection.
                </i>
            </div>
            )}
            
      </fieldset>

      

      {formData?.miscMatters?.subject4975 === 'true' && (
      <fieldset className="form-field">
        <legend>
          If the Subscriber checked “True” to the foregoing question and the Subscriber is an individual retirement account that is subject to Code §4975 (an “IRA”), is the decision to invest in the Fund being made by the IRA owner?
        </legend>
        <label>
          <input
            type="radio"
            name="miscMatters.iraDecisionSPV"
            value="true"
            checked={formData?.miscMatters?.iraDecisionSPV === 'true'}
            onChange={handleChange}
            required
          />
          Yes
        </label>
        <br />
        <label>
          <input
            type="radio"
            name="miscMatters.iraDecisionSPV"
            value="false"
            checked={formData?.miscMatters?.iraDecisionSPV === 'false'}
            onChange={handleChange}
          />
          No
        </label>
      </fieldset>
    )}

<fieldset className="form-field">
  <legend>
    (b) The Subscriber hereby notifies the General Partner and the Fund that it is a “Non-U.S. Partner” (as defined in the Fund Agreement).
  </legend>

  <label>
    <input
      type="radio"
      name="miscMatters.nonUsMemberStatus"
      value="true"
      checked={formData?.miscMatters?.nonUsMemberStatus === 'true'}
      onChange={handleChange}
      required
    />
    Yes
  </label>
  <br />

  <label>
    <input
      type="radio"
      name="miscMatters.nonUsMemberStatus"
      value="false"
      checked={formData?.miscMatters?.nonUsMemberStatus === 'false'}
      onChange={handleChange}
    />
    No
  </label>
</fieldset>


<fieldset className="form-field">
  <legend>
    (c) The Subscriber represents that it is (check one or, if none apply, explain):
  </legend>

  <label>
    <input
      type="radio"
      name="miscMatters.representType"
      value="individualHuman"
      checked={
        formData?.investorType === 'individual' ||
        formData?.miscMatters?.representType === 'individualHuman'
      }
      onChange={handleChange}
      required
      disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse' || formData?.investorType === 'selfDirectedIRA' || formData?.investorType === 'revocableGrantorTrust' }
    />
    (1) an individual human being
  </label>
  <br />

  <label>
    <input
      type="radio"
      name="miscMatters.representType"
      value="jointTenancy"
      checked={
        formData?.investorType === 'jointSpouse' ||
        formData?.miscMatters?.representType === 'jointTenancy'
      }
      onChange={handleChange}
      disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse' || formData?.investorType === 'selfDirectedIRA' || formData?.investorType === 'revocableGrantorTrust' }
    />
    (2) a joint tenancy comprised solely of individual human beings
  </label>
  <br />

  <label>
    <input
      type="radio"
      name="miscMatters.representType"
      value="grantorTrust"
      checked={
        formData?.investorType === 'revocableGrantorTrust' || 
        formData?.miscMatters?.representType === 'grantorTrust'}
      onChange={handleChange}
      disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse' || formData?.investorType === 'revocableGrantorTrust' || formData?.investorType === 'selfDirectedIRA'}
    />
    (3) a revocable grantor trust
  </label>
  <br />

  {formData?.investorType === 'revocableGrantorTrust' && (
    <div className="represents">
      <label>The sole settlor(s) of which is/are:</label>
      <br />
      <label style={{ marginLeft: '80px' }}>
        <input
          type="text"
          name="miscMatters.grantorTrustSettlor1"
          value={formData?.miscMatters?.grantorTrustSettlor1 || ''}
          onChange={handleChange}
          placeholder="Individual's Name"
          required
          style={{ width: '20%' }}
          disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse'}
        />
      </label>
      <br />
      <label style={{ marginLeft: '80px' }}>
        <input
          type="text"
          name="miscMatters.grantorTrustSettlor2"
          value={formData?.miscMatters?.grantorTrustSettlor2 || ''}
          onChange={handleChange}
          placeholder="Second Individual's Name (if applicable)"
          style={{ width: '20%' }}
          disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse'}
        />
      </label>
      <br />
    </div>
  )}

  <label>
    <input
      type="radio"
      name="miscMatters.representType"
      value="retirementAccount"
      checked={formData?.miscMatters?.representType === 'retirementAccount'}
      onChange={handleChange}
      disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse' || formData?.investorType === 'revocableGrantorTrust'}
    />
    (4) an individual retirement account
  </label>
  <br />

  {formData?.miscMatters?.representType === 'retirementAccount' && (
    <div className="represents">
      <label>
        For:<span className="tab-space"></span>
        <input
          type="text"
          name="miscMatters.retirementAccountInd"
          value={formData?.miscMatters?.retirementAccountInd || ''}
          onChange={handleChange}
          placeholder="Individual's Name"
          required
          style={{ width: '20%' }}
          disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse'}
        />
      </label>
      <br />
    </div>
  )}

  <label>
    <input
      type="radio"
      name="miscMatters.representType"
      value="selfRetirement"
      checked={formData?.miscMatters?.representType === 'selfRetirement'}
      onChange={handleChange}
      disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse' || formData?.investorType === 'revocableGrantorTrust' }
    />
    (5) a self-directed employee benefit plan
  </label>
  <br />

  {formData?.miscMatters?.representType === 'selfRetirement' && (
    <div className="represents">
      <label>
        For:<span className="tab-space"></span>
        <input
          type="text"
          name="miscMatters.selfRetirementInd"
          value={formData?.miscMatters?.selfRetirementInd || ''}
          onChange={handleChange}
          placeholder="Individual's Name"
          required
          style={{ width: '20%' }}
          disabled={formData?.investorType === 'individual' || formData?.investorType === 'jointSpouse'}
        />
      </label>
      <br />
    </div>
  )}

  {(
    formData?.investorType === 'individual' ||
    formData?.investorType === 'jointSpouse' ||
    formData?.investorType === 'revocableGrantorTrust'
  ) && (
    <div style={{ marginTop: '10px' }}>
      ⚠️ <i>This answer was auto-populated based on your previous responses. If you think the answer is incorrect,
      please review your investor type selection.</i>
    </div>
  )}

{formData?.investorType === 'selfDirectedIRA'  && (
    <div style={{ marginTop: '10px', fontSize: '12px' }}>
      <strong>    
      If Subscriber selects (4) or (5) above, Subscriber hereby represents and warrants that Subscriber has discussed this investment and its tax consequences with Subscriber’s tax advisor.
      </strong>
    </div>
  )}
</fieldset>


      <label className="form-field">
        (d) The {" "}
        {formData.investorType === 'individual'
          ? 'natual person'
          : formData.investorType === 'jointSpouse'
          ? 'individuals comprising the joint tenancy'
          : formData.investorType === 'revocableGrantorTrust'
          ? 'grantor of the trust'
          : 'individual beneficiary of the retirement plan'}{" "}
        described in Part I(a) above {" "}
        {formData.investorType === 'jointSpouse'
          ? 'are'
          : 'is'}{" "} 
        a citizen of the following country:<span className="tab-space"></span>
          <select
            name="selectedCountry"
            value={formData?.selectedCountry}
            onChange={handleChange}
            required
          >
          <option value="">Select a Country</option>
          {countries
              .filter(country => country && country.code)
              .map(country => (
                  <option key={country.code} value={country.name}> 
                      {country.name}
                  </option>
          ))}
      </select>
      </label><br/>

      <br></br>

      <label className="form-field">
        (e) The{" "}
        {formData.investorType === 'individual'
          ? 'natual person'
          : formData.investorType === 'jointSpouse'
          ? 'individuals comprising the joint tenancy'
          : formData.investorType === 'revocableGrantorTrust'
          ? 'grantor of the trust'
          : 'individual beneficiary of the retirement plan'}{" "}
        described in Part I(a) above {" "}
        {formData.investorType === 'jointSpouse'
          ? 'are'
          : 'is'}{" "} 
        domiciled in:
        <span className="tab-space"></span>

        <input
          type="text"
          name="domicileSelectedCity"
          value={formData?.domicileSelectedCity}
          onChange={handleChange}
          placeholder="City"
          style={{ marginRight: '5px' }}
          required
        />

        <input
          type="text"
          name="domicileSelectedState"
          value={formData?.domicileSelectedState}
          onChange={handleChange}
          placeholder="State or Province"
          required
        />
      </label>
      <br />

    </div>
  );
};

export default MiscellaneousMatters;
